// eslint-disable-next-line import/no-cycle
import Etch from './Etch.component';

export default Etch;
